import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  get as getVoucher,
  set as setVoucher,
  update as updateVoucher,
} from '$redux/vouchers/actions';

import Title from 'ui/Title';
import Loading from '$routes/Loading';
import Failed from '$routes/Failed';

import Form from '../Form';

class Vouchers extends React.Component {
  componentDidMount() {
    const { dispatch, match: { params: { id } } } = this.props;
    dispatch(getVoucher(id));
  }

  onUpdate = () => {
    const { dispatch, data } = this.props;
    dispatch(updateVoucher(data.idVoucher, data));
  }

  set = (key, value) => {
    const { dispatch } = this.props;
    dispatch(setVoucher(key, value));
  }

  render() {
    const {
      data,
      ui,
      loading,
      match: { params: { id } },
    } = this.props;

    if (loading) return <Loading />;
    if (!data) return <Failed />;

    return (
      <div>
        <Title>Editar código promocional #{id}</Title>
        <Form
          action="edit"
          data={data}
          ui={ui}
          set={this.set}
          onSend={this.onUpdate}
        />
      </div>
    );
  }
}

Vouchers.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.object,
  ui: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
};

Vouchers.defaultProps = {
  data: null,
  ui: null,
};

export default connect(
  state => ({
    data: state.vouchers.single,
    ui: state.vouchers.ui,
    loading: state.vouchers.loading,
  }),
)(Vouchers);
